<template>
  <div class="logo">
    <router-link :to="{name:'dashboard'}">
      <!-- <img src="~@/assets/logo.svg" alt="logo">  -->
      <img :src="coverImgUrl" alt="logo">
      <h1 v-if="showTitle">{{ title }}</h1>
    </router-link>
  </div>
</template>

<script>
  import { getAction } from '@/api/manage'
  export default {
    name: "Logo",
    data () {
      return {
        coverImgUrl:{},
      }
    },
    created () {
      //个性化首页和logo标识
      if(myPersonalizationSetData == null) {
        let wPath = window.location.href;
        getAction("/show/personalization/queryByPath", { 'path': wPath }).then((res) => {
          if (res.success) {
            //console.log(res.result);
            if (res.result) {
              myPersonalizationSetData = res.result;
            } else {
              myPersonalizationSetData = defaultPersonalizationSetData;
            }
          } else {
            myPersonalizationSetData = defaultPersonalizationSetData;
          }
          this.coverImgUrl = myPersonalizationSetData.logoUrl;
        });
      } else {
        this.coverImgUrl = myPersonalizationSetData.logoUrl;
      }

    },
    props: {
      title: {
        type: String,
        default: '管理平台',
        required: false
      },
      showTitle: {
        type: Boolean,
        default: true,
        required: false
      }
    }
  }
</script>
<style lang="scss" scoped>
  /*缩小首页布 局顶部的高度*/
  .sider .logo {
    height: 59px!important;
    line-height: 59px!important;
  }
</style>